import {MyCollections} from "@/api/types/my-collections";

interface Language  {
    code: string;
    name: string;
    flagCode: string;
}

function createLanguageFromDb(language: MyCollections["languages"]): Language {
    return <Language>{
        code: language.code,
        flagCode: language.flag_code,
        name: language.name,
    }
}

export {Language, createLanguageFromDb}